// import AdminLayout from "../../../Layout/AdminLayout";
import TransactionHistory from "./modules/TransactionHistory";
import { useParams } from "react-router-dom";

export const MemberHistory = () => {
  console.log(useParams());
  return <TransactionHistory />;
};
